import { Paperclip } from "lucide-react";
import React, { useContext } from "react";
import { ActionIcon, Menu } from "@mantine/core";
import { Navigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import { AuthContext } from "../../../providers/AuthProvider";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type DownloadAnnouncementAttachmentActionIconProps = {
  fileUrl: string;
};
/**
 * Response for downloading the annnouncement attachment
 * @param DownloadAnnouncementAttachmentActionIconProps
 * @returns React.FC
 */
const DownloadAnnouncementAttachmentActionIcon: React.FC<
  DownloadAnnouncementAttachmentActionIconProps
> = ({ fileUrl }) => {
  const auth = useContext(AuthContext);
  const { showToast } = useToasts();

  const [opened, handlers] = useDisclosure(false);

  if (!auth) {
    return <Navigate replace to="/login" />;
  }

  const handleDownload = (): void => {
    // The backend now returns a viewable URL for both Filestack and GCS attachments
    // Simply open the URL directly
    window.open(fileUrl, "_blank")?.focus();
    showToast({ strapiId: "announcement_file_attachment_downloaded" });
  };

  return (
    <Menu
      opened={opened}
      onOpen={handlers.open}
      onClose={handlers.close}
      control={
        <ActionIcon onClick={() => handlers.toggle()}>
          <Paperclip size={18} />
        </ActionIcon>
      }
    >
      <Menu.Item onClick={handleDownload}>Download File</Menu.Item>
    </Menu>
  );
};

export default DownloadAnnouncementAttachmentActionIcon;
